import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import {
  Card,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap'
import AdminForms from './AdminForms'
import EmployeeForms from './EmployeeForms'
import './style.css'
import CreateEditForm from './CreateEditForm'
import CreateEditSection from './CreateEditSection'
import { createFormSection } from 'store/Forms/actions'

const filterNumber = (...filters) => {
  let filterCount = 0

  filters.forEach((filter) => {
    if (filter) filterCount++
  })

  return filterCount
}

function MaintenanceLog() {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const [showAddFormModal, setShowAddFormModal] = useState(false)
  const [showAddSectionModal, setShowAddSectionModal] = useState(false)
  const [showFiltersModal, setShowFiltersModal] = useState(false)
  const [selectedSectionFilter, setSelectedSectionFilter] = useState(null)
  const [selectedSectionName, setSelectedSectionName] = useState('')
  const [navigationHistory, setNavigationHistory] = useState([])

  const [adminFormsLength, setAdminFormsLength] = useState(0)
  const [employeeFormsLength, setEmployeeFormsLength] = useState(0)

  const [search, setSearch] = useState('')

  const [activeFilter, setActiveFilter] = useState(null)

  // State for auto-opening form from URL parameter
  const [autoFillFormId, setAutoFillFormId] = useState(null)

  const {
    user: { access },
  } = useSelector((store) => store.auth)

  const {
    selectedStartDate,
    selectedLocation,
    selectedStatus,
    formsLoading,
    forms,
  } = useSelector((store) => store.form)

  const numOfFilters = filterNumber(
    selectedStartDate,
    selectedLocation,
    selectedStatus
  )

  // Handle fillForm URL parameter
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const fillFormId = urlParams.get('fillForm')

    if (fillFormId) {
      setAutoFillFormId(parseInt(fillFormId))
    }
  }, [location.search])

  // Function to remove fillForm parameter from URL
  const removeFillFormFromUrl = () => {
    const urlParams = new URLSearchParams(location.search)
    urlParams.delete('fillForm')

    const newSearch = urlParams.toString()
    const newUrl = newSearch
      ? `${location.pathname}?${newSearch}`
      : location.pathname

    history.replace(newUrl)
    setAutoFillFormId(null)
  }

  const handleSectionClick = (sectionId) => {
    const section = forms?.find(
      (form) => form.id === sectionId && form.is_section
    )

    // Add current section to navigation history
    if (selectedSectionFilter !== null) {
      setNavigationHistory((prev) => [
        ...prev,
        { id: selectedSectionFilter, name: selectedSectionName },
      ])
    }

    setSelectedSectionFilter(sectionId)
    setSelectedSectionName(section?.title || 'Unknown Section')
  }

  const goBackOneLevel = () => {
    if (navigationHistory.length > 0) {
      // Go back to previous level
      const previousLevel = navigationHistory[navigationHistory.length - 1]
      setSelectedSectionFilter(previousLevel.id)
      setSelectedSectionName(previousLevel.name)
      setNavigationHistory((prev) => prev.slice(0, -1))
    } else {
      // Go back to top level
      setSelectedSectionFilter(null)
      setSelectedSectionName('')
    }
  }

  return (
    <>
      <Container className='mt--6' fluid>
        <Card className='mt--6 py-4 ' style={{ minHeight: '85vh' }}>
          <div className='d-flex justify-content-between align-items-center px-3'>
            <div className='d-flex align-items-center'>
              {[1, 2, 4, 5].includes(access) ? (
                <div className='d-flex align-items-center'>
                  <button
                    type='button'
                    onClick={() => setShowAddSectionModal(true)}
                    className='btn btn-info'
                  >
                    Add Section
                  </button>
                  <button
                    type='button'
                    onClick={() => setShowAddFormModal(true)}
                    className='btn btn-info w-fit ml-3'
                  >
                    Add Form
                  </button>
                </div>
              ) : null}
              <button
                onClick={() => setShowFiltersModal(true)}
                className='btn btn-info w-fit ml-3 position-relative'
              >
                Filters
                {numOfFilters > 0 ? (
                  <div className='rounded-circle  bg-danger text-white filter-count'>
                    {numOfFilters}
                  </div>
                ) : null}
              </button>
              {selectedSectionFilter && (
                <div className='ml-3 d-flex align-items-center'>
                  <span className='text-muted mr-2'>Viewing section:</span>
                  <span className='badge badge-warning mr-2'>
                    {selectedSectionName}
                  </span>
                  <button
                    className='btn btn-sm btn-outline-secondary'
                    onClick={goBackOneLevel}
                  >
                    ← Back
                  </button>
                </div>
              )}
            </div>
            <InputGroup className='w-25'>
              <Input
                defaultValue={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={'Search forms'}
                type='text'
                bsSize='sm'
                style={{
                  padding: '18px',
                }}
              />
              <InputGroupAddon addonType='append'>
                <InputGroupText style={{ backgroundColor: '#01A0F2' }}>
                  <button
                    style={{
                      fontSize: '15px',
                      height: '10px',
                    }}
                    className='border-0 bg-transparent d-flex  justify-content-center align-items-center'
                  >
                    <i class='fas fa-search search-icon'></i>
                  </button>
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </div>

          {access === 1 && adminFormsLength ? (
            <div className='w-100 bg-secondary mt-5 py-2 d-flex align-items-center justify-content-between px-5'>
              <p className='text-dark invisible flex-item-employee'>Title</p>
              <p className='font-weight-bold flex-item-employee'>Title</p>
              <p className='font-weight-bold flex-item-employee'>Date</p>
              <p className='text-dark invisible flex-item-employee'>Title</p>
            </div>
          ) : null}

          {access !== 1 && employeeFormsLength ? (
            <div className='w-100 bg-secondary mt-5 py-2 d-flex align-items-center justify-content-between px-5'>
              <p className='text-dark invisible flex-item-employee '>Title</p>
              <p className='font-weight-bold flex-item-employee '>Title</p>
              <p className='font-weight-bold flex-item-employee '>Date</p>
              <p className='font-weight-bold flex-item-employee invisible'>
                Action
              </p>
            </div>
          ) : null}

          {formsLoading && (
            <div
              className='d-flex flex-column justify-content-center align-items-center loading-forms'
              style={{ gap: '20px' }}
            >
              <div className='spinner-border text-primary' role='status'>
                <span className='sr-only'>Loading...</span>
              </div>
              <span className='ml-2 text-muted'>Loading forms...</span>
            </div>
          )}

          {access === 1 && !adminFormsLength && !formsLoading && (
            <p className='no-forms-available text-no-forms'>
              No forms available.
            </p>
          )}

          {access !== 1 && !employeeFormsLength && !formsLoading && (
            <p className='no-forms-available text-no-forms'>
              No forms available.
            </p>
          )}
          {showAddFormModal && (
            <CreateEditForm
              showAddFormModal={showAddFormModal}
              setShowAddFormModal={setShowAddFormModal}
            />
          )}

          {showAddSectionModal && (
            <CreateEditSection
              showModal={showAddSectionModal}
              setShowModal={setShowAddSectionModal}
            />
          )}

          {access === 1 ? (
            <AdminForms
              searchFilter={search}
              setShowAddFormModal={setShowAddFormModal}
              showAddFormModal={showAddFormModal}
              showFiltersModal={showFiltersModal}
              setShowFiltersModal={setShowFiltersModal}
              setAdminFormsLength={setAdminFormsLength}
              selectedSectionFilter={selectedSectionFilter}
              onSectionClick={handleSectionClick}
              autoFillFormId={autoFillFormId}
              removeFillFormFromUrl={removeFillFormFromUrl}
            />
          ) : (
            <EmployeeForms
              searchFilter={search}
              activeFilter={activeFilter}
              showFiltersModal={showFiltersModal}
              setShowFiltersModal={setShowFiltersModal}
              setEmployeeFormsLength={setEmployeeFormsLength}
              selectedSectionFilter={selectedSectionFilter}
              onSectionClick={handleSectionClick}
              autoFillFormId={autoFillFormId}
              removeFillFormFromUrl={removeFillFormFromUrl}
            />
          )}
        </Card>
      </Container>
    </>
  )
}

export default MaintenanceLog
